import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Icon, ListItem, List } from '@ui-kitten/components';
import { StyleSheet, ScrollView, Dimensions, Image, View } from 'react-native';
import trackerApi from '../../api/tracker';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useIsFocused } from "@react-navigation/native";
import * as RootNavigation from '../../../root.navigation.js';


const width = Dimensions.get('window').width;
const height = Dimensions.get('window').height;


const PlusIcon = (props) => (
  <Icon {...props} name='plus-square-outline' />
);

  // const data = new Array(8).fill({
  //   title: 'عنوان',
  //   description: 'وضعیت',
  // });

  export const SpeechScreen = () => {
    const [data, setData] = useState([]);
    const [user, setUser] = useState();
    const isVisible = useIsFocused();

    React.useEffect(()=>{
      getData()
    },[isVisible])
    const getData = async()=>{
      const token =  await AsyncStorage.getItem('userId');
      const response = await trackerApi.post('/tickets/agentTickets', null, {
        headers: {Authorization: `Bearer ${token}`}
      });
      console.log('\x1b[36m%s\x1b[0m', 'test', response.data.allData);
      setData(response.data.allData);
      setUser(response.data.user);
    }
    const renderItem = ({ item, index }) => (
      <ListItem
        key={index}
        style={{borderWidth:1, borderColor:'#134A93', borderRadius:10, marginHorizontal:15, marginVertical:5}}
        title={(
          <View style={{flexDirection:'row'}}>
          <View style={{flexDirection:'row', alignItems:'center', justifyContent:'space-between'}}>
          <View style={{flexDirection:'row', alignItems:'center', justifyContent:'space-between'}}>
            <Text>{item.topic} </Text>
            { item.unseen > 0 && <Text status='danger' category='c1' style={{marginHorizontal: 10}}>{item.unseen} پیام</Text>}
            </View>
            <View style={{alignItems: 'flex-end'}}>
              <View style={{flexDirection:'row', alignItems:'center'}}>
                <Text status='primary' category='c1'>تیکت   </Text>
                <Text status='primary' category='h5'> # {item.id}</Text>
              </View>

            </View>
            </View>
          </View>
        )}
        onPress={()=>{RootNavigation.navigate('Chat', {query: item, user})}}
        description={`وضعیت: ${item.resolved? 'تیکت بسته شده است' : 'فعال'}`}

    />
    );
  return (

    <ScrollView>
    <Layout level='2' style={{justifyContent:'space-between', alignItems:'center'}}>
    {!data.length>0 &&
      <>
      <Image source= {require('../../../assets/empty.png')} style={{width:400*0.5, height:400*0.5, marginTop:height/3-400/4}} />
      <Text appearance='hint' style={{margin:25, textAlign:'center'}}>پیامی برای نمایش وجودندارد. لطفا در صورت نیاز به پشتیبانی درخواست جدید ثبت نمایید.</Text>
      </>
    }
    {data.length>0&&
    <Text status='primary' style={{marginVertical:15, marginHorizontal:5}}>لیست درخواست‌ها</Text>
  }
    {data.length>0&&
    <List
       style={styles.container}
       data={data}
       renderItem={renderItem}
     />
    }

     </Layout>

</ScrollView>
  );
};

const styles = StyleSheet.create({
  container:{
    height: height*0.67,
    width
  },
});
